<template>
  <div class="amplification-wrap">
    <div class="amplification" @click="amplification = !amplification">
      <button>
        <svg class="Icon Icon--plus" role="presentation" viewBox="0 0 16 16">
          <g
            stroke="currentColor"
            fill="none"
            fill-rule="evenodd"
            stroke-linecap="square"
          >
            <path d="M8,1 L8,15"></path>
            <path d="M1,8 L15,8"></path>
          </g>
        </svg>
      </button>
    </div>
    <div
      class="amplification amplification_click"
      v-if="amplification"
      @click="amplification = !amplification"
    >
      <button>
        <svg class="Icon Icon--close" role="presentation" viewBox="0 0 16 14">
          <path
            d="M15 0L1 14m14 0L1 0"
            stroke="currentColor"
            fill="none"
            fill-rule="evenodd"
          ></path>
        </svg>
      </button>
    </div>
    <div class="pswp" v-if="amplification">
      <div class="pswp_bg"></div>
      <div class="pswp_scroll_wrap"></div>
      <v-productSwiper
        v-if="amplification"
        :gallery="gallery"
        :option="{
          ...swiperOptions,
          initialSlide: activeIndex,
          width: screenWidth,
        }"
        :showNavButton="true"
      >
        <template v-slot:prev>
          <button>
            <svg
              class="Icon Icon--arrow-left"
              role="presentation"
              viewBox="0 0 11 21"
              style="width: 20px"
            >
              <polyline
                fill="none"
                stroke="currentColor"
                points="10.5 0.5 0.5 10.5 10.5 20.5"
                stroke-width="1.25"
              ></polyline>
            </svg>
          </button>
        </template>
        <template v-slot:next>
          <button>
            <svg
              class="Icon Icon--arrow-right"
              role="presentation"
              viewBox="0 0 11 21"
              style="width: 20px"
            >
              <polyline
                fill="none"
                stroke="currentColor"
                points="0.5 0.5 10.5 10.5 0.5 20.5"
                stroke-width="1.25"
              ></polyline>
            </svg>
          </button>
        </template>
      </v-productSwiper>
    </div>
  </div>
</template>
<script>
import vProductSwiper from "../../../views/venue/js/view/product/productSwiper.vue";

export default {
  props: [
    "gallery",
    "pic_zoom",
    "pagination_style",
    "theme",
    "activeIndex",
    "screenWidth",
  ],
  data() {
    return {
      swiperOptions: {
        autoHeight: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: false,
        noSwiping: true,
        noSwipingClass: "swiper-no-swiping",
      },
      amplification: false,
    };
  },
  components: {
    vProductSwiper,
  },
};
</script>
<style scoped lang='scss'>
.amplification-wrap {
  display: none;
}
.amplification {
  position: absolute;
  top: 10px;
  right: 20px;
  z-index: 20;
  button {
    width: 35px;
    height: 35px;
    box-shadow: 0 1px 5px rgb(54 54 54 / 43%);
    color: rgba(0, 0, 0, 0.5);
    border: none;
    border-radius: 50%;
    background: #fff;
    cursor: pointer;
    text-align: center;
    z-index: 1;
    -webkit-box-shadow: 0 2px 10px rgb(54 54 54 / 15%);
    box-shadow: 0 2px 10px rgb(54 54 54 / 15%);
    vertical-align: middle;
    line-height: 0;
    -webkit-transform: scale(1.001);
    transform: scale(1.001);
    -webkit-transition: background 0.15s ease-in-out, opacity 0.15s ease-in-out,
      color 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
    transition: background 0.15s ease-in-out, opacity 0.15s ease-in-out,
      color 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
    transition: background 0.15s ease-in-out, opacity 0.15s ease-in-out,
      transform 0.2s ease-in-out, color 0.2s ease-in-out;
    transition: background 0.15s ease-in-out, opacity 0.15s ease-in-out,
      transform 0.2s ease-in-out, color 0.2s ease-in-out,
      -webkit-transform 0.2s ease-in-out;
    overflow: hidden;
    &:hover {
      color: #000;
      transform: scale(1.15);
    }
  }
  svg {
    height: 14px;
    width: 14px;
    display: inline-block;
    fill: currentColor;
    vertical-align: middle;
    stroke-width: 1px;
    background: 0 0;
    pointer-events: none;
  }
}
.pswp {
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  -ms-touch-action: none;
  touch-action: none;
  z-index: 1500;
  -webkit-text-size-adjust: 100%;
  outline: 0;
  &::v-deep {
    .pswp-prev {
      display: block !important;
      position: fixed !important;
      bottom: 50px !important;
      top: initial !important;
      left: calc(50% - 82.5px) !important;
    }
    .pswp-next {
      display: block !important;
      position: fixed !important;
      bottom: 50px !important;
      top: initial !important;
      left: calc(50% + 47.5px) !important;
    }
    .pswp-prev,
    .pswp-next {
      button {
        width: 45px;
        height: 45px;
        box-shadow: 0 1px 5px rgb(54 54 54 / 43%);
        color: rgba(0, 0, 0, 0.5);
        border: none;
        border-radius: 50%;
        background: #fff;
        cursor: pointer;
        text-align: center;
        z-index: 1;
        -webkit-box-shadow: 0 2px 10px rgb(54 54 54 / 15%);
        box-shadow: 0 2px 10px rgb(54 54 54 / 15%);
        vertical-align: middle;
        line-height: 0;
        -webkit-transform: scale(1.001);
        transform: scale(1.001);
        -webkit-transition: background 0.15s ease-in-out,
          opacity 0.15s ease-in-out, color 0.2s ease-in-out,
          -webkit-transform 0.2s ease-in-out;
        transition: background 0.15s ease-in-out, opacity 0.15s ease-in-out,
          color 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
        transition: background 0.15s ease-in-out, opacity 0.15s ease-in-out,
          transform 0.2s ease-in-out, color 0.2s ease-in-out;
        transition: background 0.15s ease-in-out, opacity 0.15s ease-in-out,
          transform 0.2s ease-in-out, color 0.2s ease-in-out,
          -webkit-transform 0.2s ease-in-out;
        overflow: hidden;
        &:hover {
          color: #000;
          transform: scale(1.15);
        }
      }
      svg {
        height: 14px;
        width: 14px;
        display: inline-block;
        fill: currentColor;
        vertical-align: middle;
        stroke-width: 1px;
        background: 0 0;
        pointer-events: none;
      }
    }
    .hidden-btn {
      display: none !important;
    }
  }
  .pswp_bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    opacity: 1;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    will-change: opacity;
    -webkit-transition: none;
    transition: none;
  }
  .pswp_scroll_wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
.amplification_click {
  position: fixed;
  left: calc(50% - 22.5px);
  bottom: 45px;
  top: initial;
  right: initial;
  z-index: 9999;
  button {
    width: 55px;
    height: 55px;
  }
}
@media screen and (max-width: 768px) {
  .amplification-wrap {
    display: block;
  }
}
</style>